import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './styles/tokens.css'
import './styles/base.css'

const racine = document.getElementById('racine')
if (!racine) throw new Error('point de montage introuvable')

createRoot(racine).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
